import { IResourceConfig } from "@/constants/resources";

const noun = (config: IResourceConfig, count: number) =>
  count > 1 ? config.plural : config.singular;

//* « 3 formations », « 1 formateur »
export const countLabel = (config: IResourceConfig, count: number) =>
  `${count} ${noun(config, count)}`;

//* Accorde un participe avec la ressource : « sélectionné » → « sélectionnées »
export const agree = (word: string, config: IResourceConfig, count: number) =>
  `${word}${config.feminine ? "e" : ""}${count > 1 ? "s" : ""}`;

//* Libellé de la barre de sélection, après le nombre : « formations sélectionnées »
export const resourceSelectionLabel =
  (config: IResourceConfig) => (count: number) =>
    `${noun(config, count)} ${agree("sélectionné", config, count)}`;

export const actionVerb = (config: IResourceConfig) =>
  config.effect === "archive" ? "Archiver" : "Supprimer";

export const actionNoun = (config: IResourceConfig) =>
  config.effect === "archive" ? "Archivage" : "Suppression";

//* Bilan : « 198 supprimées »
export const doneLabel = (config: IResourceConfig, count: number) =>
  agree(config.effect === "archive" ? "archivé" : "supprimé", config, count);
